import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getBenefits(groupBy = ""): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Benefits/List${groupBy ? `?${groupBy}=true` : ''}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getBenefitId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Benefits/GetBenefit/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getBenefitsPerSupplier(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Benefits/GetBenefitsPerSupplier/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function createBenefit(data: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Benefits/Create', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  });
}

export function updateBenefitId(id: string, data: FormData): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Benefits/UpdateBenefit/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  });
}

export function softDeleteBenefitId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Benefits/SoftDeleteBenefit/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function visibleBenefitId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Benefits/VisibleBenefit/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}